export enum EndpointTypeEnum {
  Form = 'Form',
  Pdf = 'Pdf',
  Xls = 'Xls',
  Settings = 'Settings',
}



// WEBPACK FOOTER //
// ./src/app/enums/endpoint-type.enum.ts